import { MvtBasesInOut } from './mvt-basis-in-out.model'
export interface MvtBasis {
  basis: Basis[]
  mvtBases?: MvtBasesInOut
}

export interface Basis {
  basisId: number
  basisType: BasisType
  checked: boolean
  prefix: string
  name?: string
}

export interface MvtBasisSelection {
  basis: Basis
  accounts: number[]
  bookValue: boolean
  marketValue: boolean
}

export enum BasisType {
  ANY = 'ANY',
  GAAP = 'GAAP',
  STAT = 'STAT',
  TAX = 'TAX',
}

export const commonBasisTypes: Basis[] = [
  {
    basisId: 1,
    basisType: BasisType.GAAP,
    checked: false,
    prefix: 'GAAP',
    name: 'GAAP',
  },
  {
    basisId: 2,
    basisType: BasisType.STAT,
    checked: false,
    prefix: 'STAT',
    name: 'STAT',
  },
  {
    basisId: 3,
    basisType: BasisType.TAX,
    checked: false,
    prefix: 'TAX',
    name: 'TAX',
  },
]
